module.exports = __webpack_public_path__ + "img/best-redactions.13718814.svg";